import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class RoleService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
              ) { }

   getRole(isActive:number=-1) {

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

        return this.http.get(this.global.httpUrl+"roles"+isAvailable);
   }

   getRoleById(id: any) {
        return this.http.get(this.global.httpUrl+"roles/"+id);
   } 

   createRole(data: any){
        return this.http.post(this.global.httpUrl+"roles", data); 
   }

   updateRole(data: any,id: any){
        return this.http.put(this.global.httpUrl+"roles/"+id, data); 
   } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/roles/role.service.ts